<template>
  <div class="employee">
    <div id="heading">
      <div class="header-icon fa fa-users"></div>
      <h1>Coverage for Your Employees</h1>
    </div>
    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <div class="text-center">
            <h2>Protection and Assurance for your Employees</h2>
          </div>

          <p>Your business is a multifaceted machine that requires protection at every level.
            The people who make your business go deserve the assurance that they are covered at all costs.
            At SIG & Associates, we understand that quality coverage options for your employees will
            ensure that your business attracts and maintains the best workers.</p>

          <p>At SIG & Associates, we work hard to provide the best protection plans for businesses and their employees.
            Our coverage options for employees include:</p>

          <ul>
            <li class="list-item link" @click="handleModal()" data-page="disability">
              Disability Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="retire">
              Employer-Sponsored Retirement
            </li>
            <li class="list-item link" @click="handleModal()" data-page="group-d">
              Group Disability Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="benefits">
              Group Benefits
            </li>
            <li class="list-item link" @click="handleModal()" data-page="life">
              Individual Life Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="health">
              Retiree Health Coverage
            </li>
            <li class="list-item link" @click="handleModal()" data-page="voluntary">
              Voluntary Benefits
            </li>
          </ul>

          <p><small><i>SIG & Associates provides insurance coverage for employees to businesses in Wichita Falls,
            Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>
        </div>
        <hr>
        <div class="content">
          <GetQuoteForm class="get-quote"/>
        </div>
        <hr>
      </div>
    </section>
    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>
</template>

<script>
import Vue from 'vue'

import Modal from '@/widgets/Modal'
import GetQuoteForm from '@/components/GetQuoteForm'

import employeeHelper from '../helpers/employeeHelper.js'

Object.defineProperty(Vue.prototype, '$employeeHelper', {value: employeeHelper})
Vue.component('modal')

export default {
  name: 'Personal',
  methods: {
    handleModal: function () {
      let action = event.target.attributes['data-page'].value

      this.modalHeader = this.templates[action].header
      this.modalBody = this.templates[action].body

      this.showModal = true
    }
  },
  data: function () {
    return {
      showModal: false,
      modalHeader: '',
      modalBody: '',
      templates: this.$employeeHelper
    }
  },
  components: {
    Modal,
    GetQuoteForm
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.list-item.link {
  cursor: pointer;
  padding: 10px;
}

.list-item.link:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/Employees.vue